import { isClientMember, isOrgMember } from 'src/services/permission/permission.helpers';
import { ILoginState } from '../login/login.initial-state';
import { ReduxState } from '../redux-state';
import { IUserState } from './user.initial-state';

export function getIsUserAuthenticated(state: ReduxState): boolean {
  if (state && 'userState' in state && 'extUserId' in state.userState) {
    const { extUserId, access } = state.userState;
    return Boolean(extUserId && access);
  }

  return false;
}

export function getIsUserSuperAdmin(state: ReduxState): boolean {
  return getIsUserAuthenticated(state) && state.userState.isSuperAdmin;
}

export function getIsUserClient(state: ReduxState): boolean {
  return Boolean(getIsUserAuthenticated(state) && isClientMember(state.userState.permissions));
}

export function getIsUserOrg(state: ReduxState): boolean {
  return Boolean(getIsUserAuthenticated(state) && isOrgMember(state.userState.permissions));
}

export const getLoginState = (state: ReduxState): ILoginState => {
  // @ts-expect-error typing issue
  return state.loginState;
};

// export const getUserB2BOnboardStatus = (state: ReduxState): boolean => {
//   return state.userState.setupProfile;
// };

export const getUser = (state: ReduxState): Partial<IUserState> => {
  return state.userState;
};

// export const getUserSubscription = (state: ReduxState) => {
//   return state.userState.subscription;
// };

